module.exports = __webpack_public_path__ + "img/69.d259c5a5.jpg";